import {observable, action, computed, toJS} from 'mobx';
import {token} from "../libs/localStorage";

class RolePermissionStore {
  @observable items = null;
  @observable defaultPermissions = []
  transportLayer;

  constructor(transportLayer) {
    this.transportLayer = transportLayer;
  }

  @computed get allPermissions(){
    return !!this.items && this.items.length > 0 ? this.items.map(perm => perm.name) : [];
  }

  validateRole(permission){
    return +token.getDecoded().role_id === 1 || (this.allPermissions.indexOf(permission) === -1 ? true : token.getPermissions().indexOf(permission) > -1);
  }

  @action fetchAllRoles(){
    this.transportLayer.fetchAll().then(res => {
      this.items = res
    }).catch(console.error);
  }

  @action fetchRolesById(id){
    return this.transportLayer.crudAccess.fetchById(id);
  }

  @action addRolePermission = async (json) => {
    const res = await this.transportLayer.create(json);
    json.map(item => this.items.push(item));
    return(await res)
  };

  @action deleteRolePermission = async (resource) => {
    const res = await this.transportLayer.remove({resource});
    this.items = this.items.filter(item => item.resource !== resource);
    return(await res);
  };

  @action fetchDefaultPermissions(){
    this.transportLayer.fetchDefaultPermissions().then(json => {
      this.defaultPermissions = json;
    })
  }
}

export default RolePermissionStore;



// WEBPACK FOOTER //
// ./src/stores/RolePermissionStore.js